import { render } from "./BackSection.vue?vue&type=template&id=da960bce&scoped=true"
import script from "./BackSection.vue?vue&type=script&lang=js"
export * from "./BackSection.vue?vue&type=script&lang=js"

import "./BackSection.vue?vue&type=style&index=0&id=da960bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da960bce"]])

export default __exports__